document.addEventListener('DOMContentLoaded', function(){

	/* Global constants
	==================================== */
	const
		b = $('body'),
		isTouchDevice = () => {
			return(
				('ontouchstart' in window) ||
				(navigator.maxTouchPoints > 0) ||
				(navigator.msMaxTouchPoints > 0)
			);
		};

	/* Easing
	==================================== */
	const
		speed   = 300,
		speedx2 = speed*2,
		ease = $.bez([.45, .05, .19, 1]);

	/* Init
	==================================== */
	function heightViewport(){
		document.documentElement.style.cssText = `
			--height-viewport: ${window.innerHeight}px;
			--height-viewport-small: ${window.innerHeight - $('footer').outerHeight(true)}px;
		`;
	}

	/* Device detection
	==================================== */
	if(/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera) || isTouchDevice() == true){

		//If device
		b.addClass('mobile');

		//Pseudoclass :active on devices
		document.addEventListener('touchstart', function(){}, {passive: true});

		//Resize Functions
		window.addEventListener('orientationchange', function(){
			setTimeout(function(){
				heightViewport()
			}, 50);
		});

		//Product card
		$('[data-hover]').on('touchstart', function(){
			if(typeof $(this).data('hover') !== 'undefined'){
				$(this).attr('src', $(this).data('hover'))
			}
		}).on('touchend', function(){
			if(typeof $(this).data('hover') !== 'undefined'){
				$(this).attr('src', $(this).data('src'))
			}
		})

	}else{

		//if Desktop
		b.addClass('desktop');

		//Resize Functions
		window.onresize = function(){
			heightViewport()
		}

		//Coordinates
		$(document).mousemove(function(e){
			if(b.hasClass('template-index')){
				var x = e.clientX.toString(),
					 y = e.clientY.toString();
				if(x < 10) x = '0'+x;
				if(x < 100) x = '0'+x;
				if(x < 1000) x = '0'+x;
				if(y < 10) y = '0'+y;
				if(y < 100) y = '0'+y;
				if(y < 1000) y = '0'+y;
				$('#h-left').text(x.slice(0, 2))
				$('#e-left').text(x.slice(2))
				$('#h-right').text(y.slice(0, 2))
				$('#e-right').text(y.slice(2))
			}
		});

	}

	/* Clearing format
	==================================== */
	if($('.clear-format').length){
		$('.clear-format').html(function(i, html){
			return html.replace(/&nbsp;/g, ' ');
		});
		$('.clear-format *:not(.exclude, br, table), .shopify-section.clear-format').each(function(){
			$(this).filter(function(){
				return $(this).text().trim().length == 0;
			}).remove();
		});
	}

	/* Loader
	==================================== */
	heightViewport()
	if(!b.hasClass('template-index')){
		setTimeout(function(){
			$('#loader').fadeOut(speedx2);
			$('#he-lock-up_wrapper').fadeOut(speedx2)
		}, speedx2);
	}else{
		setTimeout(function(){
			$('#loader').fadeOut(speedx2, function(){
				$('#he-lock-up_wrapper').addClass('visible')
			});
		}, 1000);
	}

	/* Cookies
	==================================== */
	const cookies = $('#cookies-bar');
	if(localStorage.getItem('he-cookies_bar')){
		cookies.remove()
	}
	$('.cookies-trigger').click(function(){
		var choice = $(this).attr('id');
		cookies.slideToggle(speedx2, ease, function(){
			localStorage.setItem('he-cookies_bar', choice);
		});
	})

	/* Scroll Down
	==================================== */
	$('#scroll-down').click(function(){
		$(this).addClass('transition').hide().removeClass('active')
		$('html, body').animate({
			scrollTop: window.innerHeight/2
		}, speedx2, ease);
	});
	$(window).scroll(function(){
		if($('#scroll-down').length){
			if($(window).scrollTop() > 0){
				$('#scroll-down').addClass('transition').hide()
			}else{
				$('#scroll-down').fadeIn(speedx2, function(){
					$(this).removeClass('transition')
				})
			}
		}
	})

	/* Menu
	==================================== */
	const menu = $('#menu-main'),
			menus = $('#menus-wrapper'),
			header = $('#header-desktop')
			navCurrent = $('#nav-mobile_current'),
			navBack = $('#nav-mobile_back')

	function openTargetMenu(n){
		n.addClass('open')
		 .animate({
			opacity: 1,
			queue: false
		}, speedx2, function(){
			b.removeClass('transition')
		});
	}
	function showMenu(t, n){
		t.addClass('active')
		b.addClass('transition overlay-menu')
		header.addClass('active')
		n.show()
		menus.toggle('slide', {
			direction: 'up',
			easing: ease,
			complete: function(){
				openTargetMenu(n)
			}
		}, speedx2);
	}
	function resetMenu(){
		b.removeClass('transition')
		header.removeClass('active')
		$('[data-menu]').removeClass('active')
		$('#menus-wrapper menu').css('opacity', '0').removeClass('open').hide()
		navBack.text('MENU')
		navCurrent.hide()
	}
	function hideMenu(t, n){
		t.removeClass('active')
		b.addClass('transition').removeClass('overlay-menu')
		menus.toggle('slide', {
			direction: 'up',
			easing: ease,
			complete: function(){
				resetMenu()
			}
		}, speedx2)
		n.animate({
			opacity: 0,
			queue: false
		}, speed);
		header.hide()
		$('#nav-mobile').hide()
	}

	//Menu main
	$('[data-menu]').click(function(e){
		var t = $(this),
			 n = $(t.data('menu')),
			 txt_targ = t.text();

		if(!b.hasClass('transition')){

			e.stopPropagation()

			if(t.hasClass('active')){

				hideMenu(t, n)

			}else{

				if(window.innerWidth > 834){

					if(menus.is(':visible')){
						var active = $('menu:not(#menu-main):visible');
						$('[data-menu].active').not(t).removeClass('active')
						active.animate({
							opacity: 0,
							queue: false
						}, speed)
						t.addClass('active')
						b.addClass('transition')
						n.slideToggle(speedx2, ease, function(){
							active.removeClass('open').slideToggle(speedx2, ease)
							openTargetMenu(n)
						});
					}else{
						showMenu(t, n)
					}

					header.show()
					$('#nav-mobile').show().css('display', 'grid')
					navCurrent.show()

				}else{

					t.addClass('active')
					b.addClass('transition overlay-menu')
					header.addClass('active')
					menu.fadeOut(speed, function(){
						n.show()
						menus.fadeIn(speedx2, function(){
							openTargetMenu(n)
						})
						navCurrent.fadeIn(speedx2)
					})

				}

				navBack.text('BACK')
				navCurrent.text(txt_targ)

			}
		}
	})
	header.click(function(e){
		e.stopPropagation()
	})
	$(document).click(function(){
		if(b.hasClass('overlay-menu')){
			var n = $('menu:not(#menu-main):visible')
				 t = $('[data-menu="#'+n.attr('id')+'"]')
			hideMenu(t, n)
		}
	})

	//Menu Mobile Open
	$('#trigger-menu').click(function(){
		if(!b.hasClass('transition')){
			b.addClass('transition')
			header.toggle('slide', {
				direction: 'right',
				easing: ease,
				complete: function(){
					$('#nav-mobile, #menu-main').fadeIn(speedx2, function(){
						b.removeClass('transition')
					})
				}
			}, speedx2);
		}
	})

	//Menu Mobile Close
	$('#nav-mobile_close').click(function(){
		if(!b.hasClass('transition') && header.is(':visible')){
			b.addClass('transition').removeClass('overlay-menu')
			header.toggle('slide', {
				direction: 'right',
				easing: ease,
				complete: function(){
					resetMenu()
				}
			}, speedx2)
			$('#nav-mobile, #menu-main, #menus-wrapper').fadeOut(speed)
		}
	})

	//Menu Back
	navBack.click(function(){
		b.addClass('transition').removeClass('overlay-menu')
		navBack.text('MENU')
		navCurrent.fadeOut(speed)
		menus.fadeOut(speed, function(){
			menu.fadeIn(speedx2)
			resetMenu()
		})
	})

	/* Search
	==================================== */
	$('#search input').keyup(function(){
		var t = $(this),
			 b = t.next('button');
		if(t.val() != ''){
			b.show()
		}else{
			b.hide()
		}
	})

	/* Location
	==================================== */
	const locationSelector = $('select.location-selector');
	function updateLocationSelect(){
		b.append(
			'<span class="location_selected" style="display: none">'
				+ locationSelector.find('option:checked').text() +
			'</span>'
		);
		locationSelector.css('width', 'calc(' + $('.location_selected').width() + 'px + var(--gap-s) + var(--gap-xs)*2)');
		$('.location_selected').remove();
	}
	if(locationSelector.length){
		setTimeout(function(){
			updateLocationSelect()
		}, speedx2);
		locationSelector.change(function(e){
			updateLocationSelect()
			$('#form-location').submit()
		})
	}

	/* Currency
	==================================== */
	const api = "https://api.exchangerate-api.com/v4/latest/EUR";
	const currencySelector = $('select.currency-selector');
	function updateCurrencySelect(){
		b.append(
			'<span class="currency_selected" style="display: none">'
				+ currencySelector.find('option:checked').text() +
			'</span>'
		);
		currencySelector.css('width', 'calc(' + $('.currency_selected').width() + 'px + var(--gap-s) + var(--gap-xs)*2)');
		$('.currency_selected').remove();
	}
	function changeCurrency(conversion){
		$('html').attr('currency', conversion)
		fetch(`${api}`)
			.then((response) => response.json())
			.then((data) => {
				let x = data.rates['EUR'],
					 y = data.rates[conversion];
				$('.money').each(function(e){
					var t = $(this),
						 val = t.attr('val').split('.').join(''),
						 money = (y/x)*val,
						 txt = money.toLocaleString("en", {
							minimumFractionDigits: 0,
							maximumFractionDigits: 0,
						})
					t.text(txt.replace(',', '.'));
				})
			});
	}
	if(currencySelector.length){
		setTimeout(function(){
			updateCurrencySelect()
		}, speedx2);
		var currency = sessionStorage.getItem('currency')
		if(currency != 'EUR' && currency != null && currency != ''){
			var conversion = currency;
			changeCurrency(conversion)
			$('select.currency-selector option[value='+conversion+']').attr('selected', 'selected')
		}
		currencySelector.change(function(e){
			var conversion = $(this).val();
			changeCurrency(conversion)
			sessionStorage.setItem('currency', conversion);
			if(window.innerWidth <= 834 && $('#header-desktop').is(':visible')){
				$('#header-desktop').hide()
			}
			updateCurrencySelect()
		})
	}

	/* Sections
	==================================== */
	$('.module-section_title').click(function(index){
		var t = $(this),
			 n = t.next('.collapsed'),
			 p = t.closest('.module-sections');
		if(n.length && !$('.module-section_title.transition').length){
			t.addClass('transition')
			if(p.find('.collapsed').not(n).is(':visible')){
				p.find('.module-section_title').removeClass('active')
				t.addClass('active')
				if($('.focal').length){
					$('.focal').removeClass('active')
					t.parents('.module-article_products-wrapper').find('.focal').eq(t.parent().index()).addClass('active')
				}
				p.find('.collapsed:visible').slideUp(speedx2, ease, function(){
					n.slideDown(speedx2, ease, function(){
						t.removeClass('transition')
					});
				});
			}else{
				t.toggleClass('active')
				if($('.focal').length){
					t.parents('.module-article_products-wrapper').find('.focal').eq(t.parent().index()).toggleClass('active')
				}
				n.slideToggle(speedx2, ease, function(){
					t.removeClass('transition')
				});
			}
		}
	});

	/* Focals
	==================================== */
	$('.focal').click(function(index){
		var t = $(this).parent().next().find('.module-section_title').eq($(this).index()),
			 n = t.next('.collapsed');
		if(n.length){
			if(!t.hasClass('transition')){
				t.addClass('transition')
				if($('.module-section_title + .collapsed').not(n).is(':visible')){
					$('.module-section_title').removeClass('active')
					$('.focal').removeClass('active')
					t.addClass('active')
					$(this).addClass('active')
					$('.module-section_title + .collapsed:visible').slideUp(speedx2, ease, function(){
						n.slideDown(speedx2, ease, function(){
							t.removeClass('transition')
						});
					});
				}else{
					t.toggleClass('active')
					$(this).toggleClass('active')
					n.slideToggle(speedx2, ease, function(){
						t.removeClass('transition')
					});
				}
			}
		}
	});

	/* Filters Trigger
	==================================== */
	$('.trigger-filter').click(function(){
		var t = $(this);
		if(!t.hasClass('transition')){
			t.addClass('transition')
			 .toggleClass('active')
			 .siblings('.trigger-filter_close').toggle()
			 .parent().next('.module-filters').slideToggle(speedx2, ease, function(){
				t.removeClass('transition')
			});
		}
	});
	$('.trigger-filter_close').click(function(){
		var t = $(this).siblings('.trigger-filter')
		if(!t.hasClass('transition')){
			t.addClass('transition').removeClass('active')
			 .siblings('.trigger-filter_close').hide()
			 .parent().next('.module-filters').slideUp(speedx2, ease, function(){
				t.removeClass('transition')
			});
		}
	});

	/* Filters
	==================================== */
	$('.filter:not(.sort)').click(function(){
		var t = $(this),
			 active = t.parents('.filters-wrapper').find('input'),
			 type = t.data('type'),
			 val = t.data('filter');

		//Pos
		$(window).scrollTop(0);

		//Active/deactive filter
		t.toggleClass('active');

		//Hide projects
		$('.product, .universe-article').addClass('active-'+type);

		//Filter
		active.toggleClass(val);
		var fa = active.attr('class'),
			 ca = fa.split(/\s+/);
		$.each(ca, function(index, v){
			$('.product' + v).removeClass('active-'+type);
			$('.universe-article' + v).removeClass('active-'+type);
		});

		//Clear
		if($('.filter[data-type="'+type+'"].active').length == 0){
			$('.product, .universe-article').removeClass('active-'+type);
		}

		//Products count
		if(b.hasClass('template-blog')){
			var count = $('.universe-article:visible').length;
			$('.module-title_title .counter').text(count)
		}else{
			$('.module-collection_wrapper').each(function(){
				var t = $(this),
					 count = t.find('.product:not(.active-typology, .active-material, .active-color, .active-size)').length;
				t.find('.module-title_title .counter').text(count)
				if(count == 0){
					if(!t.is(':first-child')){
						t.show().hide()
					}
				}else{
					t.show()
				}
			})
		}

		//Filters active acount
		var count = $('.filter:not(.sort).active').length;
		$('.trigger-filter .counter').text(count)

		if(count > 0){
			b.addClass('filter-active')
			$('.trigger-filter_clear').show()
		}else{
			b.removeClass('filter-active')
			$('.trigger-filter_clear').hide()
		}

	});

	//Clear filters
	$('.trigger-filter_clear').click(function(){
		$('.trigger-filter_clear').hide()
		$('.trigger-filter .counter').text('0')
		$('.filter:not(.sort)').removeClass('active');
		$('.filters-wrapper input').removeClass()
		$('.product, .universe-article').removeClass('filtered active-typology active-material active-color active-size active-year active-tag active-category');
		var target = $('.product')
		if(b.hasClass('template-blog')){
			target = $('.module-list_row-wrapper')
		}
		$('.module-title_title .counter').text(
			target.length
		)
	});

	/* Sort
	==================================== */
	function sortList(t, k, p, target){
		target.sort(function(a, b){
			if(!t.hasClass('active')){
				return $(b).data(k) > $(a).data(k) ? 1 : -1;
			}else{
				return $(b).data(k) < $(a).data(k) ? 1 : -1;
			}
		}).prependTo(p);
	}
	$('[data-sort]').click(function(){
		var t = $(this),
			 k = t.data('sort'),
			 p = $('.module-list_content'),
			 target = p.find('.module-list_row-wrapper:not([data-'+k+'="null"])');
		t.toggleClass('active');
		$('[data-sort]').not(t).removeClass('active');
		sortList(t, k, p, target)
		if(b.hasClass('template-blog')){
			p = $('.module-gallery'),
			target = p.find('.module-gallery_block');
			sortList(t, k, p, target)
		}
	});

	//Sort
	$('.filter.sort').click(function(){
		var t = $(this),
			 k = t.data('value');
		t.siblings().removeClass('active');
		if(!t.hasClass('active')){
			t.addClass('active');
			$('.module-collection').each(function(){
				var p = $(this);
				p.find('.product:not([data-'+k+'="null"])').sort(function(a, b){
					if(!t.hasClass('invert')){
						return $(b).data(k) < $(a).data(k) ? 1 : -1;
					}else{
						return $(b).data(k) > $(a).data(k) ? 1 : -1;
					}
				}).prependTo(p);
			})
		// }else{
		// 	t.removeClass('active');
		// 	$('.module-collection').each(function(){
		// 		var t = $(this);
		// 		t.find('.product[data-'+k+']').sort(function(a, b){
		// 			return $(b).data('pos') < $(a).data('pos') ? 1 : -1;
		// 		}).prependTo(t);
		// 	})
		}
	});

	/* Pop–ups
	==================================== */
	function hidePopUp(){
		b.addClass('transition').removeClass('overlay')
		$('.module-popup:visible').toggle('slide', {
			direction: 'right',
			easing: ease,
			complete: function(){
				b.removeClass('transition')
				$(this).find('.form-field').blur().val('')
			}
		}, speedx2);
		$('.module-popup_content').fadeOut(speed)
	}
	$('[data-popup]').each(function(){
		var t = $(this),
			 popup = $(t.data('popup'));
		t.click(function(e){
			if(!b.hasClass('transition')){
				e.stopPropagation()
				b.addClass('transition overlay')
				popup.toggle('slide', {
					direction: 'right',
					easing: ease,
					complete: function(){
						popup.find('.module-popup_content').fadeIn(speedx2, function(){
							b.removeClass('transition')
							popup.find('input').first().focus()
						})
					}
				}, speedx2);
			}
		})
	});
	$('.module-popup').click(function(e){
		e.stopPropagation()
	})
	$('.trigger-popup_close').click(function(){
		hidePopUp()
	})
	$(document).click(function(){
		if($('.module-popup:visible').length){
			hidePopUp()
		}
	})

	/* Notify Me
	==================================== */
	$('#notifyme-trigger').click(function(e){
		e.stopPropagation()
		// var css = $('link[href*="blessifyinfotech"]')
		// if(css.length){
		// 	css.each(function(e){
		// 		$(this).prop('disabled', true).removeAttr('href');
		// 	})
		// }
		var popup = $('#popup-notifyme');
		if(!b.hasClass('transition')){
			b.addClass('transition overlay')
			$('#form-notifyme .module-form_message-thanks').empty()
			popup.toggle('slide', {
				direction: 'right',
				easing: ease,
				complete: function(){
					popup.find('.module-popup_content').fadeIn(speedx2, function(){
						b.removeClass('transition')
						popup.find('.form-submit').css('pointer-events', 'all')
						popup.find('.form-field').first().focus().attr('disabled', false)
					})
				}
			}, speedx2);
		}
	})
	$('#form-notifyme input[type="email"]').keyup(function(){
		if(!$('#newsletter-signpopup').length){
			$('.ct_main').click()
		}
		$('#newsletter-signpopup input[type="email"]').val($(this).val())
	})
	$('#form-notifyme').submit(function(e){
		e.preventDefault()
		if($('#newsletter-signpopup').length){
			$('#newsletter-signpopup input[type="button"]').click()
			$('html').css('cursor', 'progress');
			$(this).find('.form-submit').css('pointer-events', 'none')
			$(this).find('.form-field').blur().attr('disabled', true)
			setTimeout(function(){
				$('html').css('cursor', 'auto');
				b.css('pointer-events', 'all');
				$('#form-notifyme .module-form_message-thanks').html('Thank you. Your request has been successfully registered.');
				setTimeout(function(){
					hidePopUp()
				}, 1000);
			}, 2000);
		}else{
			$('#form-notifyme input[type="email"]').focus().val('')
			$('#form-notifyme .module-form_message').html('Something went wrong. Please try again.');
		}
	})
	$(document).on('click', '.ct_main', function(e){
		e.stopPropagation()
	}).on('click', '#newsletter-signpopup input[type="button"]', function(e){
		e.stopPropagation()
	})

	/* Size Chart
	==================================== */
	$('#sizechart-trigger').click(function(e){
		var css = $('link[href*="kiwisizing"]')
		if(css.length){
			css.each(function(e){
				$(this).prop('disabled', true).removeAttr('href');
			})
		}
		//Reset size chart
		$('#popup-sizechart .ks-tab-headers input').prop('checked', false).first().prop('checked', true)
		$('#popup-sizechart .ks-tab-panel').removeClass('selected').first().addClass('selected')
	})

	/* Recommender
	==================================== */
	$('#recommender-trigger').click(function(e){
		var css = $('link[href*="kiwisizing"]')
		if(css.length){
			css.each(function(e){
				$(this).prop('disabled', true).removeAttr('href');
			})
		}
		//Reset recommender
		$('.ks-calculator-page-result button.ks-calculator-button.back').click()
	})

	/* Switch cols
	==================================== */
	var cols = sessionStorage.getItem('he-cols');
	if(cols === 'max' && !b.hasClass('template-index')){
		$('.trigger[data-cols="max"]').addClass('active').siblings().removeClass('active')
		$('.module-collection').attr('data-cols', 'max');
	}
	$('.trigger[data-cols]').click(function(){
		var t = $(this),
			 cols = t.data('cols')
		t.addClass('active').siblings().removeClass('active')
		sessionStorage.setItem('he-cols', cols);
		// t.closest('.module-collection_wrapper').find('.module-collection').attr('data-cols', cols);
		$('.module-collection').attr('data-cols', cols);
	});

	var mode = sessionStorage.getItem('he-view');
	if(mode === 'img' && b.hasClass('template-blog')){
		$('.trigger[data-view="img"]').addClass('active').siblings().removeClass('active')
		b.attr('mode', 'img');
		sessionStorage.setItem('universe', true);
	}
	$('.trigger[data-view]').click(function(){
		var t = $(this),
			 mode = t.data('view')
		$(window).scrollTop(0);
		t.addClass('active').siblings().removeClass('active')
		sessionStorage.setItem('he-view', mode);
		b.attr('mode', mode);
		if(mode === 'img'){
			sessionStorage.setItem('universe', true);
		}else{
			sessionStorage.setItem('universe', false);
		}
	});

	/* Scroll Down Articles
	======================================== */
	$('.module-article_media-thumb').click(function(){
		var w = window.innerHeight;
		$('html, body').animate({
			scrollTop: w/2 - (w - $(this).outerHeight())
		}, speedx2, ease);
	})

	/* Universe
	==================================== */
	if(b.hasClass('template-blog') && $('.module-list_thumbnail').length){
		$('.module-list_thumbnail').each(function(){
			var t = $(this);
			if(t.hasClass('horizontal')){
				if(t.hasClass('big')){
					t.css({
						'--row': 1 + Math.floor(Math.random() * 8),
						'--col': 1 + Math.floor(Math.random() * 7)
					})
				}else{
					t.css({
						'--row': 1 + Math.floor(Math.random() * 9),
						'--col': 1 + Math.floor(Math.random() * 8)
					})
				}
				t.css({
					'--row_mobile': 1 + Math.floor(Math.random() * 5),
					'--col_mobile': 1 + Math.floor(Math.random() * 2)
				})
			}else{
				if(t.hasClass('big')){
					t.css({
						'--row': 1 + Math.floor(Math.random() * 5),
						'--col': 1 + Math.floor(Math.random() * 8)
					})
				}else{
					t.css({
						'--row': 1 + Math.floor(Math.random() * 7),
						'--col': 1 + Math.floor(Math.random() * 9)
					})
				}
				t.css({
					'--row_mobile': 1 + Math.floor(Math.random() * 4),
					'--col_mobile': 1 + Math.floor(Math.random() * 3)
				})
			}
		})
	}

	/* Countdowns
	==================================== */
	$('.countdown-wrapper').each(function(){
		var t = $(this),
			 timer = t.data('timer'),
			 warning = t.data('warning');

		if(timer){

			var time = 60 * t.data('timer'),
				 countdown = setInterval(function(){
					time -= 1000;
					var min = Math.floor(time / (60 * 1000));
					var sec = Math.floor((time - (min * 60 * 1000)) / 1000);
					min = min < 10 ? '0' + min : min;
					sec = sec < 10 ? '0' + sec : sec;
					if(time < 0){
						clearInterval(countdown);
						t.text(warning)
					}else{
						t.find('.minutes').text(min);
						t.find('.seconds').text(sec);
					}
				}, 1000);

		}else{

			var date = new Date(t.data('date')).getTime(),
				 countdown = setInterval(function(){

					var now = new Date().getTime(),
						 time = date - now;

					var day = Math.floor(time / (1000 * 60 * 60 * 24)),
						 hour = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
						 mins = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60)),
						 secs = Math.floor((time % (1000 * 60)) / 1000);

					day = day < 10 ? "0" + day : day;
					hour = hour < 10 ? "0" + hour : hour;
					mins = mins < 10 ? "0" + mins : mins;
					secs = secs < 10 ? "0" + secs : secs;

					if(time < 0){
						clearInterval(countdown);
						t.text(warning)
					}else{
						t.find('.days').html(day)
						t.find('.hours').html(hour)
						t.find('.minutes').html(mins)
						t.find('.seconds').html(secs)
					}
				}, 1000);

		}
	})

	/* PDP
	==================================== */
	if(b.hasClass('template-product') && $('#product-col_left .thumb').length > 1){
		//From inner scroll
		$(window).scroll(function(){
			if(window.innerWidth > 834){
				if($(this).scrollTop() >= window.innerHeight){
					$('#product-form').removeClass('scroll')
				}else{
					$('#product-form').addClass('scroll')
				}
			}
		})
		//Carrousel
		$('#product-col_left').scroll(function(){
			if(window.innerWidth <= 834){
				var target;
				$('#product-col_left .product-gallery_block').each(function(){
					if($(this).offset().left < window.innerWidth/2){
						target = $(this);
					}
				})
				// $('.product-gallery_count-current').text(target.data('pos'))
				$('.product-gallery_count span:nth-of-type('+target.data('pos')+')')
				 .addClass('active')
				 .siblings()
				 .removeClass('active')
			}
		})
	}

	/* Lightbox
	==================================== */
	function openLightbox(t, num){
		$('#product-col_left .product-gallery_block .thumb').css({
			// 'opacity': '0',
			'margin-top': '30px'
		});
		t.addClass('active').siblings().removeClass('active')
		t.find('.thumb').animate({
			// opacity: 1,
			marginTop: 0
		}, speedx2, ease);
		num.addClass('active').siblings().removeClass('active');
		if(window.innerWidth > window.innerHeight){
			t.scrollTop(0)
		}else{
			t.scrollTop(window.innerHeight - t.prop('scrollHeight')/2)
			 .scrollLeft(window.innerHeight/2 - window.innerWidth/2);
		}
	}
	function closeLightbox(t){
		$('html').removeClass('lightbox-active');
		if(window.innerWidth > 834){
			$(window).scrollTop(t.offset().top);
			$('.product-gallery_count-num').first().addClass('active').siblings().removeClass('active');
		}else{
			$('#product-col_left').scrollLeft(window.innerWidth*(t.data('pos')-1))
		}
	}
	$('#product-col_left .product-gallery_block').click(function(){
		var t = $(this),
			 num = $('.product-gallery_count-num[data-num="'+t.data('pos')+'"]');
		if(!$('html').hasClass('lightbox-active')){
			$('html').addClass('lightbox-active')
			openLightbox(t, num)
		}else{
			closeLightbox(t)
		}
	});
	$('.lightbox-close').click(function(){
		var t = $('.product-gallery_block.active');
		closeLightbox(t)
	})
	$('.product-gallery_count-num').click(function(){
		if($('html').hasClass('lightbox-active')){
			var num = $(this),
				 t = $('.product-gallery_block[data-pos="'+num.data('num')+'"]');
			openLightbox(t, num)
		}
	})

	/* Video player
	==================================== */
	$('.video-player_video').each(function(){
		// Video
		var $video = $(this),
			 $wrapper = $video.next(),
			 $play = $wrapper.find('.button-play'),
			 $sound = $wrapper.find('.button-sound'),
			 $full_screen = $wrapper.find('.button-full-screen'),
			 $progress_bar = $wrapper.find('.progress-bar'),
			 $progress = $wrapper.find('.time-bar')

		function play(){
			$video.addClass('playing');
			$video[0].play()
			$play
			 .addClass('active')
			 .text('PAUSE')
		}
		function pause(){
			$video.removeClass('playing');
			$video[0].pause()
			$play
			 .removeClass('active')
			 .text('PLAY')
		}
		function playPause(){
			if($video[0].paused){
				play()
			}else{
				pause()
			}
		}

		//Play/Pause
		$video.click(function(){
			playPause()
		});
		$play.click(function(){
			playPause()
		});

		//Mute video on button click
		$sound.click(function(){
			$(this)
			 .toggleClass('active')
			 .text($(this).text() == 'SOUND OFF' ? 'SOUND ON' : 'SOUND OFF');
			$video[0].muted = !$video[0].muted;
		});

		//Fullscreen
		$full_screen.click(function(){
			$video.toggleClass('full-screen');
			var v = $video[0];
			if(v.paused){
				play()
			}
			if(v.requestFullscreen){
				v.requestFullscreen();
			}else if(v.webkitEnterFullscreen){
				v.webkitEnterFullscreen();
			}else if(v.webkitRequestFullscreen){
				v.webkitRequestFullscreen();
			}else if(v.mozRequestFullScreen){
				v.mozRequestFullScreen();
			}else if(v.msRequestFullscreen){
				v.msRequestFullscreen();
			}
		});

		//Video duration timer
		$video.on('timeupdate', function(){
			var P = 100 * $video[0].currentTime / $video[0].duration;
			$progress.css('width', P + '%');
		}).on('ended', function(){
			$video.removeClass('playing')
			$play.removeClass('active').text('PLAY')
			$progress.css('width', '100%');
		}).on('webkitfullscreenchange webkitendfullscreen mozfullscreenchange fullscreenchange', function(e){
			var state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen,
				 event = state ? 'FullscreenOn' : 'FullscreenOff';
			if(event == 'FullscreenOff'){
				if(!$video[0].paused){
					pause()
					$video.removeClass('full-screen');
				}
			}
		});

		//Progress bar
		function updatebar(x){
			p = x - $progress.offset().left;
			P = 100 * p / $progress_bar.width();
			if(P > 100){
				P = 100;
			}
			if(P < 0){
				P = 0;
			}
			$progress.css('width', P + '%');
			$video[0].currentTime = $video[0].duration * P / 100;
		}
		var timeDrag = false;
		$progress_bar.on('mousedown', function(e){
			timeDrag = true;
			updatebar(e.pageX);
		});
		$(document).on('mouseup', function(e){
			if(timeDrag){
				timeDrag = false;
				updatebar(e.pageX);
			}
		}).on('mousemove', function(e){
			if(timeDrag){
				updatebar(e.pageX);
			}
		});

	});

	/* Article slider
	====================================  */
	$('.module-article_slider-track').scroll(function(){
		var t = $(this),
			 target;
		t.children().each(function(){
			if($(this).offset().left < window.innerWidth/2){
				target = $(this);
			}
		})
		t.next().find('.module-article_slider-current').text(target.data('pos'))
		// t.next().next().find('.module-article_slider-caption').text(target.data('caption'))
	})

	/* Cart Qty
	====================================  */
	$('.item-quantity select').each(function(){
		$(this).change(function(e){
			e.preventDefault();
			setTimeout(function(){
				$('#update-cart').click();
			}, 200);
		});
	});

	/* Shipping and Returns
	====================================  */
	const shippingSelector = $('#shipping-country');
	function updateShippingSelect(){
		b.append(
			'<span class="shipping-country_selected" style="display: none">'
				+ shippingSelector.find('option:checked').text() +
			'</span>'
		);
		shippingSelector.css('width', 'calc(' + $('.shipping-country_selected').width() + 'px + var(--gap-s) + var(--gap-xs)*2)');
		$('.shipping-country_selected').remove();
	}
	if(shippingSelector.length){
		setTimeout(function(){
			updateShippingSelect()
		}, speedx2);
		shippingSelector.change(function(){
			var o = $(this).find('option:checked'),
				 price = o.attr('data-price'),
				 delivery = o.attr('data-delivery');
			$('#shipping-price').html(price)
			$('#shipping-delivery').html(delivery)
			updateShippingSelect()
		});
	}

	/* Selectors
	==================================== */
	var selectors = $('.product-infos .product-select');
	function updateProductSelect(t){
		b.append(
			'<span class="selector-product_'+t.index()+'" style="display: none">'
				+ t.find('option:checked').text() +
			'</span>'
		);
		t.css('width', 'calc(' + $('.selector-product_'+t.index()).width() + 'px + var(--gap-s) + var(--gap-xs)*2)');
		$('.selector-product_'+t.index()).remove();
	}
	if(selectors.length){
		setTimeout(function(){
			selectors.each(function(index){
				var t = $(this);
				updateProductSelect(t)
				t.change(function(){
					updateProductSelect(t)
				})
			})
		}, speedx2);
	}

	/* Lazy Loading
	==================================== */
	function lazyLoading(t){
		if(t.tagName == 'IMG'){
			t.src = t.dataset.src;
		}
		if(t.tagName == 'VIDEO'){
			var P = t.play();
			if(P !== undefined){
				P.catch(error => {
					if($(t).hasClass('gif')){
						t.classList.add('no-autoplay');
					}else{
						t.classList.add('controls');
						t.controls = true;
					}
				});
			}
		}
		t.classList.remove('lazy')
		t.classList.add('lazyloaded')
	}

	/* Observer Functions
	==================================== */
	var L = [].slice.call(document.querySelectorAll('.lazy'));
	if('IntersectionObserver' in window){
		let l = new IntersectionObserver(function(E, observer){
			E.forEach(function(e){
				if(e.isIntersecting){
					let t = e.target;
					lazyLoading(t)
					l.unobserve(t);
				}
			});
		// }, {
		// 	rootMargin: '0px 0px 100px 0px'
		});
		L.forEach(function(t){
			l.observe(t);
		});
	}else{
		L.forEach(function(t){
			lazyLoading(t)
		});
	}

});
